import { type FC } from "react";

import { initLogger } from "~/utils/datadog/datadog";
import { hiringMessage } from "~/utils/hiringMessage";
import { printEnvironment } from "~/utils/printEnvironment";

// NOTE:
// This component is lazy loaded into /pages/_app.tsx so that is has access
// to the window object

// NOTE:
// Run the following commands as a side effect of import so that they
// only execute once, this looks like an anti-react pattern but is ok
// for these types of functions.

// Setup logger and log application environment info
void initLogger();

// Print environment infomation to console
printEnvironment();

// Hiring Message
void hiringMessage();

// export a noop component
export type ClientActionsProps = Record<string, never>;

export const ClientActions: FC<ClientActionsProps> = () => {
	return null;
};
